import { FILTER_BY } from "~/pages/Staff/assets/StaffFilter/lib";

export interface IResolveFilterToRequestReturn {
  DealerIds: string[];
  status: string[];
  country: string[];
  countryEn: string[];
  subject: string[];
  subjectEn: string[];
  city: string[];
  cityEn: string[];
  FO: string[];
  FOEn: string[];
}

export const resolveFilterToRequest = (
  filterData,
  isRu: boolean
): Partial<IResolveFilterToRequestReturn> => {
  const toStrArr: string[] = filterData.filterItems.map((el) => el.value);
  if (filterData.filterBy.value === FILTER_BY.DEALER)
    return { DealerIds: toStrArr };
  if (filterData.filterBy.value === FILTER_BY.COUNTRY)
    return {
      DealerIds: [],
      ...(isRu
        ? { country: [filterData.filterItems[0].value as string] }
        : { countryEn: [filterData.filterItems[0].value as string] }),
    };
  if (filterData.filterBy.value === FILTER_BY.AREA)
    return {
      DealerIds: [],
      ...(isRu ? { subject: toStrArr } : { subjectEn: toStrArr }),
    };
  if (filterData.filterBy.value === FILTER_BY.FO)
    return {
      DealerIds: [],
      ...(isRu ? { FO: toStrArr } : { FOEn: toStrArr }),
    };
  if (filterData.filterBy.value === FILTER_BY.CITY)
    return {
      DealerIds: [],
      ...(isRu ? { city: toStrArr } : { cityEn: toStrArr }),
    };

  // Return an empty object if no matching filterBy value is found
  return {};
};
